<!-------品目列表-------->
<template>
  <div>
    <el-button
      v-if="listedType == storageModeDict.RECRUITMENT.value"
      class="m-b-20"
      type="primary"
      @click="downloadAllCerts"
    >
      下载全部证件
    </el-button>
    <jczh-table-content
      :data="tableList"
      :option="tableConfig"
      pagination
      :total="total"
      :page.sync="page"
      :limit.sync="size"
    >
      <template v-slot:expireTime="{ row }">
        <span>{{ row.expireTime || '-' }}</span>
        <el-tag v-if="row.aboutToExpire == 1" class="m-l-6" type="warning">
          即将过期
        </el-tag>
      </template>

      <template v-slot:last>
        <el-table-column label="操作" align="center" min-width="150">
          <template slot-scope="{ row }">
            <div class="flex-align__around" style="height:16px">
              <upload
                :props-data="{
                  uploadMode: 'fileId',
                  fileIdBefore: row.certAttachmentId,
                  disabled: true,
                  fileListHiddenControl: {
                    hiddenUploadBtn: true,
                    hiddenFileName: true
                  }
                }"
              />
            </div>
          </template>
        </el-table-column>
      </template>
    </jczh-table-content>
  </div>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'

// 后端api
import { downloadAllCertApi } from '@/api/supplier-management/supplier-lib'

// mixin
import listFilterMixin from '@/mixins/list-filter-mixin'

// 字典
import {
  certStatusDict,
  storageModeDict
} from '@/dictionary/supplier-management/supplier-lib'

export default {
  components: { Upload },

  mixins: [listFilterMixin],

  props: {
    list: {
      type: Array,
      default: () => []
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    // 名单id
    listedId: {
      type: [String, Number],
      default: ''
    },

    // 供应商id
    supplierId: {
      type: [String, Number],
      default: ''
    },
    // 供应商入库方式
    listedType: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      storageModeDict,
      certStatusDict,
      // 表格数据
      total: 0,
      tableList: [],
      tableConfig: [
        { label: '证件名称', prop: 'certName' },
        { label: '存档日期', prop: 'uploadTime', minWidth: 160 },
        {
          label: '有效截止日期',
          prop: 'expireTime',
          slotName: 'expireTime',
          minWidth: 280
        },
        { label: '状态', prop: 'certStatus', tagDict: certStatusDict }
      ]
    }
  },

  computed: {},

  watch: {
    list: {
      handler(val) {
        this.page = 1
        this.getList()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 获取列表
     */
    getList() {
      // this.epitaxy()
      this.tableList = this.list.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      )
      this.total = this.list.length
    },

    /**
     * 下载全部证件
     */
    downloadAllCerts() {
      window.open(
        downloadAllCertApi({
          orderId: this.orderId,
          listedId: this.listedId,
          supplierId: this.supplierId
        }),
        '_blank'
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
